export default __webpack_public_path__ + "static/FAM1039B0X1-6ad952dc09f0a95048c10cab1e4e4adb.jpg";